import React from 'react';
import {LoadingButton} from '@mui/lab';
import {COLORS, SIZES, Typography} from '@fupa/fupa-uikit';
import {Container, Information} from 'app/components/match/matchLive/LivetickerCommon';
import styled from 'styled-components';
import {styled as muiStyled} from '@mui/material/styles';

const AssistiveText = styled.div`
  text-align: center;
  min-height: ${SIZES['20']};
  margin: ${SIZES['8']} 0;
`;

const SecondaryButton = muiStyled(LoadingButton)({
  '&, &:hover, &:active, &:focus': {
    backgroundColor: COLORS.lightestGrey,
    color: COLORS.fupaSecondary,
  },
});

interface LivetickerActionProps {
  buttonType: 'primary' | 'secondary';
  descriptiveText: string;
  error: string | JSX.Element | null;
  isLoading: boolean;
  label: string;
  onClick: () => void;
}

const LivetickerAction = ({buttonType, descriptiveText, error, isLoading, label, onClick}: LivetickerActionProps) => {
  const button =
    buttonType === 'primary' ? (
      <LoadingButton onClick={onClick} loading={isLoading} variant='contained' color='secondary'>
        {label}
      </LoadingButton>
    ) : (
      <SecondaryButton onClick={onClick} loading={isLoading} variant='contained'>
        {label}
      </SecondaryButton>
    );

  return (
    <Container>
      <Information>
        <Typography variant='body1'>{descriptiveText}</Typography>
      </Information>
      {button}
      <AssistiveText>{error ? <Typography variant='caption-error'>{error}</Typography> : null}</AssistiveText>
    </Container>
  );
};

export default LivetickerAction;
